export const UPDATE_VISIBILITY = "UPDATE_REGION_BANNER_VISIBILITY";

export const updateVisibility = (isVisible: boolean) => {
  return {
    type: UPDATE_VISIBILITY,
    payload: isVisible,
  };
};
